/* RETRIEVE EFFICIENCY BLOCK FOR MAIN PRODUCT ON PRODUCT PAGE THEN DISPLAY IT */
function getEfficiency() {

	var efficiency = document.getElementById('efficiency');

	if(efficiency) {
	    /* First get product url */
	    const urlBase = efficiency.dataset.product;

	    /* Build ajax call with collection url + sections view needed + checked filters params and values */
	    const url = urlBase + '?sections=product-reviews';

	    const request = new XMLHttpRequest();
	    request.addEventListener('loadend', efficiencyResponse);
	    request.open('GET', url, true);
	    request.send();
	}

}

function efficiencyResponse() {

	var resp = JSON.parse(this.responseText);
	var efficiencyContainer = document.getElementById('sectionRoutineEfficiency');
	efficiencyContainer.innerHTML = Object.values(resp)[0];

	var details = efficiencyContainer.querySelector('.product-reviews__details');
	efficiencyContainer.innerHTML = "";
	efficiencyContainer.appendChild(details);
}


/* RETRIEVE YOTPO REVIEW BLOC THEN DISPLAY IT IN PLACE DEFINED BY SECTION DIAGNOSTIC REVIEWS */

function displayReviews() {
	let reviewsId = document.getElementById('routineReviews');
	let finalContainer = document.getElementById('sectionRoutineReviews');

	if(reviewsId && finalContainer) {
		var reviewsBlock = reviewsId.querySelector('.routine-reviews-container');
		finalContainer.appendChild(reviewsBlock);
	}
}

/* ATUOMATIC ADD TO CART FOR E-COMMERCE DISPLAY VERSION */

function addRoutine() {
	
	var submit = document.querySelectorAll('.routineSubmit');
	var i = 0;

	/* Interval is necessary to queue API requests */
	var timer = setInterval(function() {
	     if( i < submit.length) {
	     	/* Add class to indicate that we don't need to display cart drawer after submit */
	     	 document.body.classList.add('noDrawer');
	     	/* Virtual click */
	         submit[i].click();
	     	 	 //console.log('shoudl add count');
	        /* Display added text */
	         submit[i].style.display = "block";
	         console.log("Click handler for button " + i + " fired");
	     } else {
	         clearInterval(timer);
	     }
	     i = i + 1;
	}, 950);		
}

/* MANAGE SOURCE OF VISITOR TO DISPLAY THE RIGHT ELEMS */

/* Basic function to read/get specific cookie */
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/* Check if customer came to page from physical store */
function idSource() {
	/* First check if store parameter */
	const queryString = window.location.search;	
	const urlParams = new URLSearchParams(queryString);
	const source = urlParams.get('source');
	/* If there is a param source with value store, then we store info as cookie for the duration of the session */
	if (source == 'store') {
		document.cookie = 'customerSource=' + source;
	}
}

function manageSource() {
	/* First we check if cookie customerSource with value store exists */
	var source = getCookie('customerSource');
	if(source === 'store') {
		/* If source value is store, then we add specific class to body to hide some infos */
		document.body.classList.add('sourceStore');
	} else {
		/* If not, we execute the automatic add to cart process */
		addRoutine();
		/* Then show checkout button */
		document.getElementById('routineCheckoutBtn').style.display = 'block';
	}

}

window.addEventListener("load", function(event) {
	console.log('Hello world!');
	idSource();
	manageSource();
	getEfficiency();
	displayReviews();
});